import { FC, ReactNode } from "react";
import styled from "styled-components";

const Wrapper = styled.div<{ $span?: string }>`
	display: flex;
	flex-direction: column;
	grid-column: ${({ $span }) => $span};
`;

const InfoFieldTitle = styled.div`
	font-size: ${({ theme }) => theme.fonts.sizes.small};
	font-weight: 600;
`;

interface Props {
	title: string;
	value: ReactNode;
	span?: string;
	hoverTitle?: string;
}

export const DetailsPageInfoField: FC<Props> = ({ title, value, span, hoverTitle }) => {
	return (
		<Wrapper $span={span}>
			<InfoFieldTitle>{title}</InfoFieldTitle>
			<div title={hoverTitle}>{value}</div>
		</Wrapper>
	);
};
